// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__ZaoXa","load6":"Spinner_load6__MSbrh","round":"Spinner_round__S-fr4"};